import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import type { CommunicationRecord } from "@entities";
import { CommunicationRecordManager } from "./CommunicationRecordManager";

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  opportunityId?: string;
  associationId?: string;
  groupId?: string;
  summerCampaignLeadId?: string;
  partnerOrganizationId?: string;
  volunteerOrganizationId?: string;
  type?: "volunteer" | "aid-related" | "opportunity" | "lead" | "partner-organization" | "volunteer-organization";
  onSave?: (records?: CommunicationRecord[]) => void;
};

export function CommunicationRecordsDialog({
  open,
  onClose,
  title,
  opportunityId,
  associationId,
  groupId,
  summerCampaignLeadId,
  partnerOrganizationId,
  volunteerOrganizationId,
  type,
  onSave,
}: Props) {
  const hasTarget = Boolean(
    opportunityId || associationId || groupId || summerCampaignLeadId || partnerOrganizationId || volunteerOrganizationId,
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth dir="rtl">
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Typography variant="h6" component="span" sx={{ minWidth: 0 }}>
          תיעוד תקשורת - {title}
        </Typography>
        <IconButton onClick={onClose} aria-label="סגירה" size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {open && hasTarget && (
          <CommunicationRecordManager
            opportunityId={opportunityId}
            associationId={associationId}
            groupId={groupId}
            summerCampaignLeadId={summerCampaignLeadId}
            partnerOrganizationId={partnerOrganizationId}
            volunteerOrganizationId={volunteerOrganizationId}
            type={type}
            showAllRecords
            embedded
            onSave={onSave}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
